// import React from 'react';
// import { Route, Routes } from 'react-router-dom';
// // internal
// import BackToTop from '../components/BackToTop';
// import ContextProvider from '../components/context/ContextProvider';
// import Template from '../components/Template/Template';
// import Home from '../Pages/Home/Home';
// import { Solution } from '../Pages/Solution/Solution';
// import { Resources } from '../Pages/Resources/Resource';
// import { Price } from '../Pages/Price/Price';
// import { Support } from '../Pages/Support/Support';
// import { About } from '../Pages/About/About';
// import { Contact } from '../Pages/contact/Contact';
// import  NetworkMember  from '../components/Pages/Features/Network _Membership_Management';
// import  EventWebsite  from '../components/Pages/Features/Event_Website_Registration';
// import  MeetingScheduling  from '../components/Pages/Features/One2One_Meeting_Scheduling';
// import  EventManagement  from '../components/Pages/Features/Event_Management';
// import { Demo } from '../Pages/Demo/RequestDemo';

// const AppNavigation: React.FC = () => {
//   return (
//     <ContextProvider>
//       {/* <AnimateMouse /> */}
//       <Routes>
        
//         <Route path="/" element={<Template><Home /></Template>} />
//         <Route path="/network" element={<Template><NetworkMember /></Template>} />
//         <Route path="/event" element={<Template><EventWebsite /></Template>} /> 
//         <Route path="/one2One" element={<Template><MeetingScheduling /></Template>} />
//         <Route path="/eventManagement" element={<Template><EventManagement /></Template>} />
//         <Route path='/Solutions' element={<Template><Solution /></Template>} />
//         <Route path='/Resources' element={<Template><Resources /></Template>} />
//         <Route path='/Price' element={<Template><Price /></Template>} />
//         <Route path='/Support' element={<Template><Support /></Template>} />
//         <Route path='/About_Us' element={<Template><About /></Template>} />
//         <Route path='/Contact_Us' element={<Template><Contact /></Template>} />
//         <Route path='/Demo' element={<Template><Demo /></Template>} />
//       </Routes>
//       <BackToTop />
//     </ContextProvider>
//   );
// };

// export default AppNavigation;


import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
// internal
import BackToTop from '../components/BackToTop';
import ContextProvider from '../components/context/ContextProvider';
import Template from '../components/Template/Template';
import Loader from "../components/loader"
import ErrorBoundary from "../hooks/ErrorBoundary"

// Lazy-loaded Pages
const Home = React.lazy(() => import('../Pages/Home/Home'));
const Solution = React.lazy(() => import('../Pages/Solution/Solution'));
const Resources = React.lazy(() => import('../Pages/Resources/Resource'));
const Price = React.lazy(() => import('../Pages/Price/Price'));
const Support = React.lazy(() => import('../Pages/Support/Support'));
const About = React.lazy(() => import('../Pages/About/About'));
const Contact = React.lazy(() => import('../Pages/contact/Contact'));
const NetworkMember = React.lazy(() => import('../Pages/Features/Network _Membership_Management'));
const EventWebsite = React.lazy(() => import('../Pages/Features/Event_Website_Registration'));
const MeetingScheduling = React.lazy(() => import('../Pages/Features/One2One_Meeting_Scheduling'));
const EventManagement = React.lazy(() => import('../Pages/Features/Event_Management'));
const Demo = React.lazy(() => import('../Pages/Demo/RequestDemo'));

const AppNavigation: React.FC = () => {
  return (
    <ContextProvider>
      <ErrorBoundary>
      <Suspense fallback={<Loader/>}>
        <Routes>
          <Route path="/" element={<Template><Home /></Template>} />
          <Route path="/network" element={<Template><NetworkMember /></Template>} />
          <Route path="/event" element={<Template><EventWebsite /></Template>} />
          <Route path="/one2One" element={<Template><MeetingScheduling /></Template>} />
          <Route path="/eventManagement" element={<Template><EventManagement /></Template>} />
          <Route path="/Solutions" element={<Template><Solution /></Template>} />
          <Route path="/Resources" element={<Template><Resources /></Template>} />
          <Route path="/Price" element={<Template><Price /></Template>} />
          <Route path="/Support" element={<Template><Support /></Template>} />
          <Route path="/About_Us" element={<Template><About /></Template>} />
          <Route path="/Contact_Us" element={<Template><Contact /></Template>} />
          <Route path="/Demo" element={<Template><Demo /></Template>} />
        </Routes>
      </Suspense>
      </ErrorBoundary>
      <BackToTop />
    </ContextProvider>
  );
};

export default AppNavigation;

